

<div mat-dialog-title>
  <h2>{{ "notepad.create_note_modal_title" | translate }}</h2>
  <button (click)="selfDialogRef.close()" aria-label="Close dialog" class="close">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<form (ngSubmit)="onSubmit(noteForm.value)" [formGroup]="noteForm">
  <mat-dialog-content>
    @if (isInitializing === false) {
      <div class="form-content">
        <div class="title-field">
          <mat-form-field class="w-100-p">
            <mat-label>{{ 'notepad.create_note_title_label' | translate }}</mat-label>
            <input formControlName="title" matInput
              placeholder="{{ 'notepad.create_note_title_placeholder' | translate }}"/>
              @if (noteForm.get('title').errors?.required) {
                <mat-error>
                  {{ 'generic.field.required' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      } @else {
        <mat-spinner></mat-spinner>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <button [disabled]="isSaving || isValid === false" class="button mat-button" mat-button mat-raised-button
        type="submit">
        @if (isSaving) {
          <mat-spinner></mat-spinner>
        }
        {{'generic.create_go_on' | translate}}
      </button>
    </mat-dialog-actions>
  </form>